import React from "react";

const IntroVideo = ({ videoId = "X6n4kFvpwcc", title = "Alysei Intro" }) => {
  return (
    <section
      className="relative w-full py-10 md:py-16 px-5 md:px-16 overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #e0f2fe 0%, #f0fdfa 50%, #e0f2fe 100%)",
      }}
    >
      <div className="relative z-10 w-full max-w-2xl mx-auto">
        <div
          className="relative w-full overflow-hidden rounded-2xl shadow-2xl"
          style={{
            paddingTop: "56.25%",
            boxShadow: "0 18px 36px rgba(0, 69, 119, 0.24)",
          }}
        >
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}`}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
};

export default IntroVideo;
